export default __webpack_public_path__ + "static/media/illustration_avatar.77e914e5.png";